export class OfferSetOfferModel {
  type?: string;
  title?: string;
  value?: number | string;
  afterText?: string;
  disclosure?: string;
  leaseType?: string;
  term?: number;
  termType?: string;
  moneyDown?: number;
  apr?: number;
}

export class EligibleOfferSetModel {
  id?: number;
  accountId?: number;
  title?: string;
  displayTitle?: string;
  year?: number;
  make?: string;
  model?: string;
  trim?: string;
  msrp?: number;
  buyPrice?: number;
  advertisedPrice?: number;
  suggestedMaxSalePrice?: number;
  vehicleCondition?: string;
  isPrivate?: boolean;
  offers?: OfferSetOfferModel[];
}
